import React from "react";
import RemoveDialog from "../../../Shared/Remove/RemoveDialog";
import { useAttributeFormBuilder } from "../../../../Hooks/Display/useComponentProperties";
import { useTranslation } from 'react-i18next';

const RemoveStepDialog = ({ handleClose }) => {

    const { t } = useTranslation([
        "display/components/form"
    ]);

    const [{ selectedStepId, steps }, dispatch] = useAttributeFormBuilder();
    const step = steps.find(step => step.id === selectedStepId);

    const handleRemove = () => {
        dispatch.removeStep();
        handleClose();
    }

    return (
        <RemoveDialog
            toggleDeleteDialog={handleClose}
            message={t("step.remove_step_dialog.warning", { ns: "display/components/form", stepName: step.name })}
            Title={t("step.remove_step_dialog.title", { ns: "display/components/form" })}
            deleteButtonText={t("step.remove_step_dialog.buttons.remove", { ns: "display/components/form" })}
            cancelButtonText={t("step.remove_step_dialog.buttons.cancel", { ns: "display/components/form" })}
            onDelete={handleRemove}
        />
    );
}

export default RemoveStepDialog;